import React, { useEffect, useState } from "react";
import MuiHeader from "../../components/MuiHeader";
import { useNavigate } from "react-router-dom";
import { red, blue, green, purple } from "@mui/material/colors";
import AodIcon from "@mui/icons-material/Aod";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ContentPreview from "../../components/ContentPreview";
// toastify
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// swal
import Swal from "sweetalert2";
import api from "../../api/api";

//mui
import {
  Avatar,
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
  ListItemText,
  ListItemButton,
  TextField,
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Slide,
} from "@mui/material";

import {
  getAllFlnmaster,
  updateFlnMaster,
  deleteFlnMaster,
  createAllFlnmaster,
  uploadFlnDocument,
  getFlnDocument,
  deleteFlnDocument,
} from "./FlnMasterThunk";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FlnMaster = () => {
  const navigate = useNavigate();
  // ------------ Grid gallery view -----------
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const ITEM_HEIGHT = 48;
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [selectedSegment, setSelectedSegment] = useState({});

  const [anchorEl, setAnchorEl] = useState(null);
  const openVertMenu = Boolean(anchorEl);
  const [previewContenttitle, setPreviewContenttitle] = useState("");
  const [openPreview, setOpenPreview] = useState(false);
  const [previewContent, setPreviewContent] = useState("");
  const [disable_content_button, setDisable_content_button] = useState(true);
  const [showUpdate, setShowUpdate] = useState(false);

  const handleVertMenuClose = () => {
    setAnchorEl(null);
    setSelectedIndex(-1);
    setSelectedSegment({});
  };

  const contentOnClick = (segment) => {
    //  setPreviewContenttitle(segment.displayname);
    setPreviewContent(segment.imageurl);
    setOpenPreview(true);
  };

  const handleClosePreview = () => {
    setOpenPreview(false);
  };

  const handleVertMenuClick = (event, eachsegment, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex(index);
    setSelectedSegment(eachsegment);
  };

  // --------- options for dropdowns ---------
  const language_select_option_list = [
    { value: "od", text: "ଓଡିଆ" },
    { value: "en", text: "English" },
  ];

  const program_select_option_list = [
    { value: "pge", text: "PGE" },
    { value: "ece", text: "ECE" },
  ];

  const clas_select_option_list = [
    { value: "1", text: "1" },
    { value: "2", text: "2" },
    { value: "3", text: "3" },
    { value: "4", text: "4" },
    { value: "5", text: "5" },
    { value: "6", text: "6" },
    { value: "7", text: "7" },
    { value: "8", text: "8" },
  ];

  const level_select_option_list = [
    { value: "1", text: "1" },
    { value: "2", text: "2" },
    { value: "3", text: "3" },
  ];

  const subject_select_option_list = [
    { value: "odia", text: "odia" },
    { value: "maths", text: "maths" },
    { value: "english", text: "english" },
    { value: "evs", text: "evs" },
  ];

  const skills_select_option_list = [
    { value: "foundationalliteracy", text: "Foundational Literacy" },
    { value: "foundationalnumeracy", text: "Foundational Numeracy" },
  ];

  const assesment_select_option_list = [
    { value: "baseline", text: "Baseline" },
    { value: "midline", text: "Midline" },
    { value: "endline", text: "Endline" },
  ];

  const [language, setLanguage] = useState("");
  const [program, setProgram] = useState("");
  const [clas, setClas] = useState("");
  const [level, setLevel] = useState("");
  const [subject, setSubject] = useState("");
  const [skills, setSkills] = useState("");
  const [assesment, setAssesment] = useState("");
  const [flnData, setFlnData] = useState([]);
  const [operation, setOperation] = useState("");
  const [index, setIndex] = useState(-1);
  const [modalTitle, setModalTitle] = useState("");
  const [disableAppname, setDisableAppname] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [disablePackagename, setDisablePackagename] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openModalSave, setOpenModalSave] = useState(false);
  const [flnQuestion, setFlnQuestion] = useState("");
  const [flnInstructions, setFlnInstructions] = useState("");
  const [id, setId] = useState("");
  const [docs, setDocs] = useState([]);
  ////console.log("docs--->", docs);
  const [image, setImage] = useState("");
  ////console.log("image--->", image);
  const [s3_getname, set_get_s3name] = useState("");
  ////console.log("image set---->", s3_getname);
  const [display_name, set_display_name] = useState("");
  const [file_type, set_file_type] = useState("");
  ////console.log("display_name---->", display_name);
  const handleImage = (event) => {
    setImage(event.target.files);
    for (let i = 0; i < event.target.files.length; i++) {
      let displayname = event.target.files[i].name;
      set_display_name(displayname);
      ////console.log("this.displayname-->", displayname);
      let filetype = displayname.split(".").pop();
      ////console.log("this.displayname-->", displayname);
      set_file_type(filetype);
      ////console.log(" this.filetype-->", filetype);
      let s3name = new Date().getTime() + "." + filetype;
      ////console.log("this.s3name-->", s3name);
      let currentFileUpload = event.target.files.item(i);
      ////console.log(" this.currentFileUpload-->", currentFileUpload);
      //  let uploadurl = '';
      //  uploadurl = (directory == undefined || directory == null || directory == '') ? 's3api/uploadroot/'+s3name : 's3api/uploaddir/'+directory+'/'+s3name;
      var formData = new FormData();
      formData.append("file", currentFileUpload);
      ////console.log("FormData-->", formData);
      api.post(`s3api/uploadroot/${s3name}`, formData).then(
        (response) => {
          ////console.log("response uplooad-->", response.data);
          if (response.data.s3path.length > 0) {
            alert("uploded successfully!!");
            set_get_s3name(response.data);
          }

          // setImage(response.data);
          // let body = {
          //   certificate: response.data.s3path,
          //   certificatestatus: "complete",
          // };
          // api.put(`addnsdccert/${userId}`, body).then((response) => {
          //   ////console.log("response after upload-->", response.data);
          //   if (response.data.status === "success") {
          //     alert("uploded successfully!!");
          //     event.target.value = null;
          //     // set_upload_success(true);
          //     api.get(`getnsdcappearedusers/${managerId}`).then((response) => {
          //       // ////console.log("user response--->", response.data);
          //       setUsers(response.data.data);
          //     });
          //   }
          // });
        },
        (err) => {
          ////console.log(err);
        }
      );
    }
  };

  useEffect(() => {
    const data = {
      program: program,
      clas: clas,
    };
    getFlnDocument(data).then((response) => {
      ////console.log(response.data);
      setDocs(response.data);
    });
  }, [program, clas, subject]);

  const modal_cancle_button_click = (params) => {
    // cleardata();
    setOpenModal(false);
  };
  const modal_fln_cancle_button_click = (params) => {
    // cleardata();
    setOpenModalSave(false);
  };

  const modal_save_button_click = (params) => {
    ////console.log("isUpdate: ", params);

    if (isUpdate) updatedata();

    setOpenModal(false);

    // setOpenModal(false);
  };

  const modal_fln_save_button_click = (params) => {
    ////console.log("isUpdate: ", params);

    setOpenModal(false);
    const data = {
      assessmentquestion: flnQuestion,
      class: clas,
      imageurl: s3_getname.s3path,
      instructions: flnInstructions,
      language: language,
      program: program,
      qid: new Date().getTime(),
      subject: subject,
      type: assesment,
    };
    ////console.log("data----------->", data);
    // createAllFlnmaster(data).then((response) => {
    //   ////console.log("create------>", response.data);
    // });
    createAllFlnmaster(data).then((response) => {
      ////console.log(response.data, "update------------>");
      if (response.data.status === "success") {
        const data = {
          assesment: assesment,
          language: language,
          program: program,
          clas: clas,
          subject: subject,
        };
        getAllFlnmaster(data).then((fln) => {
          // ////console.log(fln.data, "modules");
          setFlnData(fln.data);
        });
      }
    });
    // setOpenModal(false);
  };

  const language_select_onchange = (event) => {
    setLanguage(event.target.value);
  };

  const program_select_onchange = (event) => {
    setProgram(event.target.value);
  };

  const class_select_onchange = (event) => {
    setClas(event.target.value);
  };

  const level_select_onchange = (event) => {
    setLevel(event.target.value);
  };

  const subject_select_onchange = (event) => {
    setSubject(event.target.value);
  };

  const skills_select_onchange = (event) => {
    setSkills(event.target.value);
  };

  const assesment_select_onchange = (event) => {
    setAssesment(event.target.value);
    setDisable_content_button(false);
    const data = {
      assesment: event.target.value,
      language: language,
      program: program,
      clas: clas,
      subject: subject,
    };
    getAllFlnmaster(data).then((fln) => {
      // ////console.log(fln.data, "modules");
      setFlnData(fln.data);
    });
  };

  const create_content_button_click = () => {
    handleVertMenuClose();
    setIndex(index);
    setModalTitle("Create FLN Details");
    setOpenModalSave(true);
  };

  //on update
  const update_content_button_click = (eachsegment, index) => {
    ////console.log(eachsegment, "eachsegmentjkksd");
    handleVertMenuClose();
    setOperation("update");
    setIndex(index);
    setModalTitle("Update FLN Details");
    setIsUpdate(true);
    setFlnQuestion(eachsegment.assessmentquestion);
    setFlnInstructions(eachsegment.instructions);
    setId(eachsegment._id);
    setImage(eachsegment.imageurl);

    // setDisableAppname(true);
    // setDisablePackagename(true);
    setOpenModal(true);
  };

  const updatedata = () => {
    const body = {
      _id: id,
      update_fln: {
        assessmentquestion: flnQuestion,
        instructions: flnInstructions,
      },
    };
    ////console.log("body------>", body);

    updateFlnMaster(body).then((response) => {
      ////console.log(response.data, "update------------>");
      if (response.data.status === "success") {
        const data = {
          assesment: assesment,
          language: language,
          program: program,
          clas: clas,
          subject: subject,
        };
        getAllFlnmaster(data).then((fln) => {
          // ////console.log(fln.data, "modules");
          setFlnData(fln.data);
        });
      }
    });
    // dispatch(updateVersionThunk(body))
    //   .then(() => dispatch(getVersionThunk()))
    //   .then(() => dispatch(cleardata))
    //   .then(toast.success("Data updated successfully"));
  };

  //on Delete
  const delete_content_button_click = (eachsegment, index) => {
    ////console.log("each----->", eachsegment);
    handleVertMenuClose();
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      //cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteFlnMaster(eachsegment._id).then((response) => {
          ////console.log(response.data);
          if (response.data.status === "success") {
            const data = {
              assesment: assesment,
              language: language,
              program: program,
              clas: clas,
              subject: subject,
            };
            getAllFlnmaster(data).then((fln) => {
              // ////console.log(fln.data, "modules");
              setFlnData(fln.data);
            });
          }
        });
      }
    });
  };

  // fln upload document
  const upload_fln_button_click = () => {
    setShowUpdate(true);
  };
  const handleCloseUpdate = () => {
    setShowUpdate(false);
  };

  const handleSaveUploadDocument = () => {
    // assessmentquestion: flnQuestion,
    // class: clas,
    // imageurl: s3_getname.s3path,
    // instructions: flnInstructions,
    // language: language,
    // program: program,
    // qid: new Date().getTime(),
    // subject: subject,
    // type: assesment,

    const data = {
      activitydocument: s3_getname.s3path,
      class: clas,
      program: program,
      displayname: display_name,
      filetype: file_type,
    };
    ////console.log("data------>", data);
    ////console.log("data2------>", s3_getname);
    uploadFlnDocument(data).then((response) => {
      ////console.log("rtyf--->", response.data);
      if (response.data.status === "success") {
        const data = {
          program: program,
          clas: clas,
        };
        getFlnDocument(data).then((response) => {
          setDocs(response.data);
        });
      }
    });
  };

  const handleDeleteDocument = (x) => {
    deleteFlnDocument(x._id).then((response) => {
      ////console.log(response.data);
      if (response.data.status === "success") {
        const data = {
          program: program,
          clas: clas,
        };
        getFlnDocument(data).then((response) => {
          setDocs(response.data);
        });
      }
    });
  };

  return (
    <>
      <div>
        <MuiHeader header="FLN Master" />
        <FormControl
          style={{ marginTop: 73 }}
          sx={{ m: 1, minWidth: 120 }}
          size="small"
        >
          <InputLabel id="demo-select-small">Language</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={language}
            label="Language"
            onChange={language_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {language_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl
          style={{ marginTop: 73 }}
          sx={{ m: 1, minWidth: 120 }}
          size="small"
        >
          <InputLabel id="demo-select-small">Program</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={program}
            label="Language"
            onChange={program_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {program_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {program === "pge" ? (
          // <div>
          <>
            <FormControl
              style={{ marginTop: 73 }}
              sx={{ m: 1, minWidth: 120 }}
              size="small"
            >
              <InputLabel id="demo-select-small">Class</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={clas}
                label="Language"
                onChange={class_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {clas_select_option_list.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl
              style={{ marginTop: 73 }}
              sx={{ m: 1, minWidth: 120 }}
              size="small"
            >
              <InputLabel id="demo-select-small">Subject</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={subject}
                label="Language"
                onChange={subject_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {subject_select_option_list.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </>
        ) : (
          <>
            <FormControl
              style={{ marginTop: 73 }}
              sx={{ m: 1, minWidth: 120 }}
              size="small"
            >
              <InputLabel id="demo-select-small">Level</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={level}
                label="Language"
                onChange={level_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {level_select_option_list.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl
              style={{ marginTop: 73 }}
              sx={{ m: 1, minWidth: 120 }}
              size="small"
            >
              <InputLabel id="demo-select-small">Skills</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={skills}
                label="Language"
                onChange={skills_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {skills_select_option_list.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </>
        )}

        <FormControl
          style={{ marginTop: 73 }}
          sx={{ m: 1, minWidth: 120 }}
          size="small"
        >
          <InputLabel id="demo-select-small">Assesment</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={assesment}
            label="Language"
            onChange={assesment_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {assesment_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div>
        <Button
          onClick={upload_fln_button_click}
          variant="contained"
          // disabled={disable_content_button}
          style={{ marginLeft: 12, marginTop: -35 }}
        >
          Upload Activity Documents
        </Button>
        <Button
          style={{ marginTop: -35 }}
          onClick={create_content_button_click}
          variant="contained"
          disabled={disable_content_button}
        >
          Create New FLN Assesment
        </Button>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={3}>
            {flnData.map((eachsegment, index) => (
              <Grid item xs={12} sm={isSmallScreen ? 12 : 6} md={4} key={index}>
                <Card sx={{ maxWidth: 345 }}>
                  <CardHeader
                    avatar={
                      <Avatar sx={{ bgcolor: green[500] }}>
                        <AodIcon />
                      </Avatar>
                    }
                    action={
                      <>
                        <IconButton
                          id={index + 1.1}
                          onClick={(e) =>
                            handleVertMenuClick(e, eachsegment, index)
                          }
                          aria-controls={openVertMenu ? { index } : undefined}
                          aria-expanded={openVertMenu ? "true" : undefined}
                          aria-haspopup="true"
                        >
                          <MoreVertIcon />
                        </IconButton>
                      </>
                    }
                    title={
                      <div
                        style={{ cursor: "pointer", wordBreak: "break-all" }}
                        onClick={() => contentOnClick(eachsegment)}
                      >
                        {eachsegment.assessmentquestion}?
                      </div>
                    }
                    subheader={
                      <div>
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() => contentOnClick(eachsegment)}
                        >
                          Instructions :{" "}
                          {eachsegment.instructions
                            ? eachsegment.instructions
                            : ""}
                        </div>
                      </div>
                    }
                  />
                </Card>
              </Grid>
            ))}
            <Menu
              id={selectedIndex}
              anchorEl={anchorEl}
              open={openVertMenu}
              onClose={handleVertMenuClose}
              MenuListProps={{
                "aria-labelledby": "vert-button",
              }}
              PaperProps={{
                style: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  width: "20ch",
                },
              }}
            >
              <MenuItem
                onClick={() =>
                  update_content_button_click(selectedSegment, selectedIndex)
                }
              >
                Edit
              </MenuItem>
              <MenuItem
                onClick={() =>
                  delete_content_button_click(selectedSegment, selectedIndex)
                }
              >
                Delete
              </MenuItem>
            </Menu>
          </Grid>
        </Box>
      </div>
      {/* Preview */}
      <ContentPreview
        open={openPreview}
        contenttitle={previewContenttitle}
        content={previewContent}
        onClose={handleClosePreview}
      />
      {/* Loader */}
      {/* <MuiLoader open={loading} /> */}
      {/* Toaster */}
      <ToastContainer />
      {/*  update modal */}
      <Dialog
        open={openModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={modal_cancle_button_click}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{modalTitle}</DialogTitle>
        <DialogContent>
          <TextField
            disabled={disableAppname}
            id="appname"
            label="FLN Questions"
            name="appname"
            value={flnQuestion}
            onChange={(e) => setFlnQuestion(e.target.value)}
            autoComplete="appname"
            margin="normal"
            required
            fullWidth
            autoFocus
          />

          <TextField
            id="outlined-multiline-static"
            label="Instructions"
            multiline
            rows={10}
            variant="outlined"
            value={flnInstructions}
            onChange={(e) => setFlnInstructions(e.target.value)}
          />
          <img src={s3_getname} style={{ width: 120 }} />
          <TextField
            style={{ marginLeft: 9, marginTop: 12 }}
            name="upload-photo"
            type="file"
            //  value={image}
            onChange={handleImage}
          />

          {/* <TextField
            style={{ marginLeft: 9, marginTop: 12 }}
            name="upload-photo"
            type="file"
            // value={image}
            onChange={handleImage}
          /> */}

          {/* <textarea
          // value={appname}
          // onChange={(e) => setAppname(e.target.value)}
          ></textarea> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={modal_cancle_button_click}>Cancle</Button>
          <Button onClick={modal_save_button_click}>Save</Button>
        </DialogActions>
      </Dialog>
      {/* {end} */}
      {/* Modal for fln activity document */}
      <Modal
        open={showUpdate}
        onClose={handleCloseUpdate}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <FormControl
            style={{ marginTop: 73 }}
            sx={{ m: 1, minWidth: 120 }}
            size="small"
          >
            <InputLabel id="demo-select-small">Program</InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              value={program}
              label="Language"
              onChange={program_select_onchange}
            >
              <MenuItem value="">None</MenuItem>
              {program_select_option_list.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {program === "pge" ? (
            // <div>
            <>
              <FormControl
                style={{ marginTop: 73 }}
                sx={{ m: 1, minWidth: 120 }}
                size="small"
              >
                <InputLabel id="demo-select-small">Class</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  value={clas}
                  label="Language"
                  onChange={class_select_onchange}
                >
                  <MenuItem value="">None</MenuItem>
                  {clas_select_option_list.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.text}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </>
          ) : (
            <>
              <FormControl
                style={{ marginTop: 73 }}
                sx={{ m: 1, minWidth: 120 }}
                size="small"
              >
                <InputLabel id="demo-select-small">Level</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  value={level}
                  label="Language"
                  onChange={level_select_onchange}
                >
                  <MenuItem value="">None</MenuItem>
                  {level_select_option_list.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.text}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </>
          )}

          <TextField
            style={{ marginLeft: 9, marginTop: 12 }}
            name="upload-photo"
            type="file"
            // value={image}
            onChange={handleImage}
          />
          {docs.length > 0 ? (
            <div>
              <div>
                {/* <img src={docs[0].activitydocument} className="image" /> */}
                <table>
                  <thead>
                    {docs.map((x, i) => (
                      <tr>
                        <td>
                          {i + 1}.{x.activitydocument}
                        </td>
                        <td>
                          {" "}
                          <Button onClick={() => handleDeleteDocument(x)}>
                            Delete
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </thead>
                </table>
              </div>
            </div>
          ) : null}

          <Button
            variant="outlined"
            style={{ marginLeft: 12 }}
            onClick={handleCloseUpdate}
          >
            Close
          </Button>
          <Button variant="contained" onClick={handleSaveUploadDocument}>
            SAVE
          </Button>
        </Box>
      </Modal>

      {/* End modal for fln activity document*/}
      {/* save modal */}
      <Dialog
        open={openModalSave}
        TransitionComponent={Transition}
        keepMounted
        onClose={modal_cancle_button_click}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{modalTitle}</DialogTitle>
        <DialogContent>
          <TextField
            disabled={disableAppname}
            id="appname"
            label="FLN Questions"
            name="appname"
            value={flnQuestion}
            onChange={(e) => setFlnQuestion(e.target.value)}
            autoComplete="appname"
            margin="normal"
            required
            fullWidth
            autoFocus
          />

          <TextField
            id="outlined-multiline-static"
            label="Instructions"
            multiline
            rows={10}
            variant="outlined"
            value={flnInstructions}
            onChange={(e) => setFlnInstructions(e.target.value)}
          />

          <TextField
            style={{ marginLeft: 9, marginTop: 12 }}
            name="upload-photo"
            type="file"
            // value={image}
            onChange={handleImage}
          />

          {/* <textarea
          // value={appname}
          // onChange={(e) => setAppname(e.target.value)}
          ></textarea> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={modal_fln_cancle_button_click}>Cancle</Button>
          <Button onClick={modal_fln_save_button_click}>Save</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FlnMaster;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
